// src/components/audition-booking-wizard/VideoPlayModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
// import { JOGET_BASE_URL } from './utils/bookingHelpers';

const VideoPlayModal = ({ show, handleClose, videoUrl, jogetApplicationId }) => {
    // if (!videoUrl || !jogetApplicationId) return null;
    if (!videoUrl) return null;

    // const fullVideoSource = `${JOGET_BASE_URL}/jw/web/client/app/bookmyaudition/form/download/roleApplication/${jogetApplicationId}/${videoUrl}`;

    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            size="lg" 
            centered
            contentClassName="bg-dark border-0 rounded-4 overflow-hidden shadow-lg"
        >
            <Modal.Header closeButton closeVariant="white" className="border-secondary bg-black">
                <Modal.Title className="text-white fs-5">Audition Submission</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 bg-black text-center">
                {show && ( // Only render video tag when modal is truly shown to ensure autoplay
                    <video
                        // src={fullVideoSource}
                        src={videoUrl}
                        controls
                        autoPlay
                        controlsList="nodownload" // Prevent download button
                        className="w-100"
                        style={{ maxHeight: '75vh', backgroundColor: '#000' }}
                    />
                )}
            </Modal.Body>
            <Modal.Footer className="border-secondary bg-black">
                <Button variant="outline-light" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default VideoPlayModal;